
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateDocumentsMoveToProjectDtoFormGroup() {
return new FormGroup({
    newProjectId: new FormControl<number | undefined>(undefined, [Validators.required]),
    documentIds: new FormControl<Array<number> | undefined>([], [Validators.required]),
    newDocumentsubtypeId: new FormControl<number | undefined>(undefined, [Validators.required]),
})
;
}
      